// const FAQContent: React.FunctionComponent = function () {
//   return <div>f</div>;
// };

// export default FAQContent;
export interface FAQContentProps {
  text: string;
}

const FAQContent: React.FunctionComponent<FAQContentProps> = function ({
  text,
}) {
  return (
    <div className="w-full p-4 md:px-6 pt-0 text-14-22 text-neutral-700 bg-neutral-000">
      {text}
    </div>
  );
};

export default FAQContent;
